<template>
  <div class="bill-flow-minute-view">
    <BillFlowMinute />
  </div>
</template>

<script>
import BillFlowMinute from '@/components/bill/BillFlowMinute.vue'

export default {
  name: 'BillFlowMinuteView',
  components: {
    BillFlowMinute
  }
}
</script>

<style scoped>
.bill-flow-minute-view {
  flex: 1;
}
</style>
